import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  margin-bottom: 5px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid ${props => props.isValid ? '#d1d1d1' : 'red' };
`;
